export const SHIPPING_OPTION_BASDEL = 'BASDEL';
export const SHIPPING_OPTION_PICKUP = 'PICKUP';

export const SHIPPING_OPTION_IDENTIFIERS = [
  SHIPPING_OPTION_BASDEL,
  SHIPPING_OPTION_PICKUP,
];

export const ORDER_STATUS_PAYMENT_RECEIVED = 'payment-received';

export const ORDER_STATUS_FINISHED = 'finished';

export const ORDER_STATUS_CANCELED = 'canceled';

export const ORDER_STATUS_AWAITING_PAYMENT = 'awaiting-payment';

export const ORDER_STATUS_ESTIMATE = 'estimate';

export const ORDER_STATUS_INITIATED = 'initiated';

export const ORDER_STATUS_PREPARED = 'prepared';

export const ORDER_STATUS_TO_RETURN = [
  ORDER_STATUS_PAYMENT_RECEIVED,
  ORDER_STATUS_FINISHED,
  ORDER_STATUS_CANCELED,
  ORDER_STATUS_ESTIMATE,
  ORDER_STATUS_PREPARED,
];

export const SHIPPABLE_COUNTRIES = [
  'FR', // France
  'BE', // Belgique
  'CH', // Suisse
  'DE', // Allemagne
  'AT', // Autriche
  'BG', // Bulgarie
  'CY', // Chypre
  'HR', // Croatie
  'DK', // Danemark
  'ES', // Espagne
  'EE', // Estonie
  'FI', // Finlande
  'GR', // Grèce
  'HU', // Hongrie
  'IE', // Irlande
  'IT', // Italie
  'LV', // Lettonie
  'LT', // Lituanie
  'LU', // Luxembourg
  'MT', // Malte
  'MC', // Monaco
  'NL', // Pays-Bas
  'PL', // Pologne
  'PT', // Portugal
  'CZ', // République tchèque
  'RO', // Roumanie
  'SK', // Slovaquie
  'SI', // Slovénie
  'SE', // Suède
  'AD', // Andorre
  'GP', // Guadeloupe
  'GF', // Guyane française
  'MQ', // Martinique
  'RE', // Réunion
  'YT', // Mayotte
  'PM', // Saint-Pierre-et-Miquelon
  'BL', // Saint-Barthélemy
  'MF', // Saint-Martin
  'WF', // Wallis-et-Futuna
  'PF', // Polynésie française
  'NC', // Nouvelle-Calédonie
];

export const PRIMARY_BRANDS = ['RENAULT', 'PEUGEOT', 'CITROEN'];

export function getOrderStatusLabel(order) {
  switch (order.status) {
    case ORDER_STATUS_FINISHED:
      // return 'Terminée';
      if (order.shipping_address?.shipping_option === SHIPPING_OPTION_BASDEL) {
        return 'Expédiée';
      }
      return 'Retirée';
    case ORDER_STATUS_PAYMENT_RECEIVED:
      return 'Préparation en cours';
    case ORDER_STATUS_PREPARED:
      if (order.shipping_address?.shipping_option === SHIPPING_OPTION_BASDEL) {
        return 'Prête à être expédiée';
      }
      return 'Prête à être retirée';
    case ORDER_STATUS_ESTIMATE:
      return 'Estimation de livraison en cours';
    case ORDER_STATUS_AWAITING_PAYMENT:
      return 'En attente de paiement';
    default:
      return 'Annulée';
  }
}
